import { render, staticRenderFns } from "./ListCopy.vue?vue&type=template&id=46c53c48"
import script from "./ListCopy.vue?vue&type=script&lang=js"
export * from "./ListCopy.vue?vue&type=script&lang=js"
import style0 from "./ListCopy.vue?vue&type=style&index=0&id=46c53c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports